export default function pushCompareEvent(compareVehicleCount) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'compare',
        compare_vehicle: compareVehicleCount,
    });
}
